import { render, staticRenderFns } from "./interfaceManage.vue?vue&type=template&id=1112a9f1&scoped=true&"
import script from "./interfaceManage.vue?vue&type=script&lang=ts&"
export * from "./interfaceManage.vue?vue&type=script&lang=ts&"
import style0 from "./interfaceManage.vue?vue&type=style&index=0&id=1112a9f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1112a9f1",
  null
  
)

export default component.exports